module.exports = __webpack_public_path__ + "img/outgoing-mail.2d4a391c.svg";